export const GET_ALL_UI_COLOR_FONT_REQUEST = "GET_ALL_UI_COLOR_FONT_REQUEST";
export const GET_ALL_UI_COLOR_FONT_FAILURE = "GET_ALL_UI_COLOR_FONT_FAILURE";
export const GET_ALL_UI_COLOR_FONT_SUCCESS = "GET_ALL_UI_COLOR_FONT_SUCCESS";

export const CREATE_UI_COLOR_FONT_REQUEST = "CREATE_UI_COLOR_FONT_REQUEST";
export const CREATE_UI_COLOR_FONT_FAILURE = "CREATE_UI_COLOR_FONT_FAILURE";
export const CREATE_UI_COLOR_FONT_SUCCESS = "CREATE_UI_COLOR_FONT_SUCCESS";

export const UPDATE_UI_COLOR_FONT_REQUEST = "UPDATE_UI_COLOR_FONT_REQUEST";
export const UPDATE_UI_COLOR_FONT_FAILURE = "UPDATE_UI_COLOR_FONT_FAILURE";
export const UPDATE_UI_COLOR_FONT_SUCCESS = "UPDATE_UI_COLOR_FONT_SUCCESS";